// src/components/AdminNavBar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavBar.css';

const AdminNavBar = () => {
  const tabs = [
    { to: '/admin/lists',        label: 'ALL LISTS' },
    { to: '/admin/create-list',  label: 'CREATE LIST' },
    { to: '/admin/submissions',  label: 'USER SUBMISSIONS' },
  ];

  return (
    <div className="section-header">
      <div className="nav-wrap">
        <nav className="nav-tabs">
          {tabs.map(t => (
            <NavLink
              key={t.to}
              to={t.to}
              end
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default AdminNavBar;
